import React, { useEffect, useState } from 'react';
import { classGroupType } from '../../../../../constants/types/student-type';
import { LmsClassGroupType } from '../../../../../constants/types/lms-type';
import { getClassGroupList } from '../../../../../api/utils/lms/lmsApi';
import { Radio, Skeleton } from 'antd';
import TextWinds from '../../../../../components/common/TextWinds';

interface ClassAssignListProps {
  classId: string;
  selected: classGroupType | undefined;
  setSelected: React.Dispatch<React.SetStateAction<classGroupType | undefined>>;
}
const ClassAssignList = ({
  classId,
  selected,
  setSelected,
}: ClassAssignListProps) => {
  const [classList, setClassList] = useState<LmsClassGroupType[]>();
  const [selectRadio, setSelectRadio] = useState<number>(selected?.id);

  useEffect(() => {
    getClassGroupList(classId).then((res) => {
      setClassList(res.result);
    });
  }, []);

  const radioHandler = (e: any) => {
    const value = e.target.value;
    setSelectRadio(value);
    setSelected(classList?.find((item) => item.id === value));
  };

  return classList ? (
    <div className="flex h-[180px] w-full overflow-y-auto">
      {classList.length > 0 ? (
        <Radio.Group
          onChange={radioHandler}
          value={selectRadio}
          className="flex w-full flex-col gap-1"
        >
          {classList.map((classItem) => (
            <Radio
              key={classItem.id}
              value={classItem.id}
              className={`w-full rounded p-1 px-3 ${
                classItem.id === selectRadio ? 'bg-purple1' : 'bg-gray1'
              } hover:bg-purple2`}
            >
              {classItem.name}
            </Radio>
          ))}
        </Radio.Group>
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <TextWinds type="content_body3" color="gray6">
            등록된 반이 없습니다.
          </TextWinds>
        </div>
      )}
    </div>
  ) : (
    <Skeleton />
  );
};

export default ClassAssignList;
